import { type CSSProperties } from 'react';

/* ── Base skeleton block ── */

interface SkeletonProps {
  variant?: 'text' | 'title' | 'row' | 'block';
  width?: string;
  style?: CSSProperties;
}

export function Skeleton({ variant = 'block', width, style }: SkeletonProps) {
  const variantClass = variant === 'block' ? 'skeleton' : `skeleton skeleton-${variant}`;
  return (
    <div
      className={variantClass}
      aria-hidden="true"
      style={{ width, ...style }}
    />
  );
}

/* ── Table row skeleton — shows 3 rows per the spec ── */

export function TableRowSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="skeleton skeleton-row"
          aria-hidden="true"
          style={{ opacity: 1 - i * 0.15 }}
        />
      ))}
    </div>
  );
}

/* ── Card skeleton — title + a few text lines ── */

export function CardSkeleton() {
  return (
    <div style={{
      backgroundColor: 'var(--card-bg)',
      border: '1px solid var(--card-border)',
      borderRadius: 'var(--card-radius)',
      padding: 'var(--card-padding)',
      boxShadow: 'var(--card-shadow)',
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-3)',
    }}>
      <Skeleton variant="title" width="60%" />
      <Skeleton variant="text" width="100%" />
      <Skeleton variant="text" width="80%" />
      <Skeleton variant="text" width="90%" />
    </div>
  );
}
